import {useRef, useState} from 'react'
import {useSafeEffect} from '@freckle/react-hooks'
import {Spinner} from '@freckle/educator-entities/ts/common/components/spinner-wrapper/spinner'

const SPINNER_DELAY = 300

type Props = {
  text?: string | null | undefined
  inline?: boolean | null | undefined
}

export function DelayedSpinner(props: Props) {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const {text, inline} = props
  const [showSpinner, setShowSpinner] = useState<boolean>(false)

  useSafeEffect(() => {
    timer.current = setTimeout(setShowSpinner, SPINNER_DELAY, true)
    return () => {
      clearTimeout(timer.current)
      timer.current = undefined
    }
  }, [])

  return showSpinner ? <Spinner text={text} inline={inline} /> : <></>
}
